import type { IconData } from '@stacksjs/iconify-core'

export const viewStream: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64v384h480V64Zm448 32v144H48V96ZM48 416V272h416v144Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default viewStream
